// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Category } from './category';
import { User } from './user';

/**
 * 
 * @export
 * @interface Webinar
 */
export interface Webinar {
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    type?: string;
    /**
     * 
     * @type {User}
     * @memberof Webinar
     */
    owner: User;
    /**
     * 
     * @type {Category}
     * @memberof Webinar
     */
    category?: Category;
    /**
     * 
     * @type {number}
     * @memberof Webinar
     */
    viewersLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof Webinar
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof Webinar
     */
    enabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Webinar
     */
    startedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Webinar
     */
    finishedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Webinar
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Webinar
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    ownerId: string;
    /**
     * 
     * @type {number}
     * @memberof Webinar
     */
    viewersCount: number;
    /**
     * 
     * @type {string}
     * @memberof Webinar
     */
    status: WebinarStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WebinarStatusEnum {
    Coming = 'coming',
    Running = 'running',
    Finished = 'finished',
    Undefined = 'undefined'
}



